export default __webpack_public_path__ + "static/media/arrow-right-circle.d443742a.svg";